// neo_cogym — 로컬 키-값 저장소 (W2: electron-store/conf 대체)
// IndexedDB 기반(전 디바이스 지원). 동기 API가 필요한 레거시 호출(sendSync)을 위해
// 메모리 캐시를 함께 둬서 read는 동기로, write는 비동기로 영속화한다.

const DB_NAME = "neo_cogym";
const STORE = "kv";

let dbPromise: Promise<IDBDatabase> | null = null;
const cache = new Map<string, unknown>();
let hydrated = false;

function openDb(): Promise<IDBDatabase> {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

/** 앱 시작 시 1회 호출: IndexedDB → 메모리 캐시 적재(이후 동기 read 가능) */
export async function hydrate(): Promise<void> {
  if (hydrated) return;
  const db = await openDb();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const store = tx.objectStore(STORE);
    const keysReq = store.getAllKeys();
    const valsReq = store.getAll();
    tx.oncomplete = () => {
      const keys = keysReq.result as IDBValidKey[];
      const vals = valsReq.result as unknown[];
      keys.forEach((k, i) => cache.set(String(k), vals[i]));
      hydrated = true;
      resolve();
    };
    tx.onerror = () => reject(tx.error);
  });
}

export const kv = {
  /** 동기 read(캐시). hydrate() 이후 유효 */
  get<T = unknown>(key: string, fallback?: T): T | undefined {
    return (cache.has(key) ? (cache.get(key) as T) : fallback);
  },
  /** write: 캐시 즉시 갱신 + IndexedDB 비동기 영속화 */
  set(key: string, value: unknown): void {
    cache.set(key, value);
    void openDb().then((db) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.objectStore(STORE).put(value, key);
    });
  },
  delete(key: string): void {
    cache.delete(key);
    void openDb().then((db) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.objectStore(STORE).delete(key);
    });
  },
  has(key: string): boolean {
    return cache.has(key);
  },
};
